export const GEOAPIFY_API_KEY = '3304d39d4a8948dea18c872ca062f3dc';
